import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-panggilan-poli";
import httpCommon from "@/axios/http-common";
import axios from "axios";

async function call(data) {
  const response = await http.postData("/panggil", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}
/*
param: tgl, unit_id, dokter_id
*/
async function startDisplay(data) {
  const response = await http.postData("/start-display", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function setRunningText(data: { unit_id: string; message: string }) {
  const response = await http.postData("/running-text", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getStatusByRegister(registerId) {
  const response = await httpCommon
    .getData("/panggilan-layanan/register/" + registerId)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function callNext(date, unitId, cdocId) {
  const response = await httpCommon
    .getData(
      `/panggilan-layanan/${unitId}/dokter/${cdocId}/tanggal/${date}/next`
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function callNextAlternative(
  date,
  unitId,
  cdocId,
  type = null
): Promise<{
  status: string;
  q_type: string;
  nq: number;
  qtext: string;
  next_nq: number;
  next_qt: string;
}> {
  const qt = type ? `&qt=${type}` : "";

  // const response = await axios
  //   .get(
  // `http://10.10.187.6:8701/api/qdr?tgl=${date}&ut=${unitId}&dr=${cdocId}${qt}`
  //   )
  const response = await httpCommon
    .getData(`/antrian-dokter-call?tgl=${date}&ut=${unitId}&dr=${cdocId}${qt}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function updatePanggilan(date, unitId, cdocId, regId, data) {
  const response = await httpCommon
    .putData(
      `/panggilan-layanan/unit/${unitId}/dokter/${cdocId}/tanggal/${date}/register/${regId}`,
      data
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  call,
  getStatusByRegister,
  startDisplay,
  callNext,
  callNextAlternative,
  updatePanggilan,
  setRunningText
};
